module.exports = "/_next/static/images/66720d4462f0086be07ef050972a27f0-paperwork@desktop1024.jpg";